import { render } from "./smollSearch.vue?vue&type=template&id=44ec9456&scoped=true"
import script from "./smollSearch.vue?vue&type=script&lang=js"
export * from "./smollSearch.vue?vue&type=script&lang=js"

import "./smollSearch.vue?vue&type=style&index=0&id=44ec9456&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ec9456"]])

export default __exports__